import { fromUtc } from '@/tools/formatedate';
import { Ilist, ListData, ListParsedData } from './types';

const parse = (data: Ilist): ListParsedData => ({
  childId: data!.student_id || '',
  confirmationUrl: data!.confirmation_url || '',
  dateFinish: fromUtc(data!.date_finish || ''),
  result: data!.result || '',
  student_fio: data!.student_fio || '',
  title:
    data!.competition && data!.competition.name ? data.competition.name : '',
});

const parseList = (list: Array<Ilist>): ListData => {
  if (!Array.isArray(list)) return [];
  return list.map(parse);
};

export default parseList;



// WEBPACK FOOTER //
// ./src/services/noko/utils/parseList.ts